import TabButton from './TabButton';
export { TabButton };
export default TabButton;
